module.exports = __webpack_public_path__ + "static/media/28_tn.dd05bbc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/28_tn.jpg
// module id = 337
// module chunks = 0